// mobile/screens.js — the four phone screens inside the mobile hero deck (ported from
// website2m-screens.jsx). Faithful replicas of the product's mobile designs (calendar-mobile /
// bookings-mobile / clients-mobile / messaging-mobile), designed at 402×874 and scaled by
// N2Fit. Each plays a short story beat when its card is centered (`on`), driven by useN2Phases.
import React from 'react'
import { N2Ic, NIc, NPaw } from '../icons'
import { useN2Phases } from '../shell'
import { SclPetPic } from '../screens2'

function MsStatus() {
	return (
		<div className="ms-status" aria-hidden="true">
			<span>9:41</span>
			<span className="ms-status-r">
				<svg width="19" height="12" viewBox="0 0 19 12"><rect x="0" y="7.5" width="3.2" height="4.5" rx=".7" fill="#000"></rect><rect x="4.8" y="5" width="3.2" height="7" rx=".7" fill="#000"></rect><rect x="9.6" y="2.5" width="3.2" height="9.5" rx=".7" fill="#000"></rect><rect x="14.4" y="0" width="3.2" height="12" rx=".7" fill="#000"></rect></svg>
				<svg width="17" height="12" viewBox="0 0 17 12"><path d="M8.5 3.2C10.8 3.2 12.9 4.1 14.4 5.6L15.5 4.5C13.7 2.7 11.2 1.5 8.5 1.5C5.8 1.5 3.3 2.7 1.5 4.5L2.6 5.6C4.1 4.1 6.2 3.2 8.5 3.2Z" fill="#000"></path><path d="M8.5 6.8C9.9 6.8 11.1 7.3 12 8.2L13.1 7.1C11.8 5.9 10.2 5.1 8.5 5.1C6.8 5.1 5.2 5.9 3.9 7.1L5 8.2C5.9 7.3 7.1 6.8 8.5 6.8Z" fill="#000"></path><circle cx="8.5" cy="10.5" r="1.5" fill="#000"></circle></svg>
				<svg width="27" height="13" viewBox="0 0 27 13"><rect x=".5" y=".5" width="23" height="12" rx="3.5" stroke="#000" strokeOpacity=".35" fill="none"></rect><rect x="2" y="2" width="20" height="9" rx="2" fill="#000"></rect><path d="M25 4.5V8.5C25.8 8.2 26.5 7.2 26.5 6.5C26.5 5.8 25.8 4.8 25 4.5Z" fill="#000" fillOpacity=".4"></path></svg>
			</span>
		</div>
	)
}

export function MsChrome({ children, on }) {
	return (
		<div className={'ms-app v-lav ms-scr' + (on ? ' on' : '')}>
			<i className="ms-island" aria-hidden="true"></i>
			<MsStatus />
			<div className="ms-screen">{children}</div>
			<i className="ms-home" aria-hidden="true"></i>
		</div>
	)
}

export function MsTap({ show, press = false, x = '50%', y = '50%' }) {
	return <span className={'ms-tap' + (show ? ' show' : '') + (press ? ' press' : '')} style={{ '--x': x, '--y': y }} aria-hidden="true"></span>
}

function MsTopbar() {
	return (
		<div className="ms-topbar">
			<span className="ms-menu"><N2Ic name="menu" size={21} sw={1.7} /></span>
			<span className="ms-topacts">
				<span className="ms-icbtn"><NIc name="help" size={18} sw={1.6} /></span>
				<span className="ms-icbtn"><NIc name="bell" size={18} sw={1.6} /><i className="ms-dot"></i></span>
				<span className="ms-avatar">JV</span>
			</span>
		</div>
	)
}

/* ── 1 · Calendar — day schedule, Thu Jul 9 · 10:47 AM ── */
const MS_G = {
	AS: { name: 'Ashley Smith', first: 'Ashley', ac: '#7C6BD9', chip: '#EFECFB', deep: '#5245AC' },
	ML: { name: 'Marcus Lee', first: 'Marcus', ac: '#3E9BD0', chip: '#E9F4FB', deep: '#20678F' },
	PP: { name: 'Priya Patel', first: 'Priya', ac: '#46A06E', chip: '#E9F5EE', deep: '#2A6E4C' },
	JK: { name: 'Jordan Kim', first: 'Jordan', ac: '#D9912F', chip: '#FBF2E1', deep: '#8F6217' }
}
const MS_CAT = { groom: ['#EFECFB', '#7C6BD9', '#5245AC'], bath: ['#E9F4FB', '#3E9BD0', '#20678F'], puppy: ['#E9F5EE', '#46A06E', '#2A6E4C'] }
const MS_CAL = [
	{ pet: 'Luna', breed: 'Maltese', time: '9:00 – 10:15 AM', svc: 'Full Groom — Small', price: 80, add: ['Teeth Brushing'], cat: 'groom', g: 'AS', done: true },
	{ pet: 'Cooper', breed: 'Labrador', time: '10:00 – 11:15 AM', svc: 'Full Groom — Large', price: 110, add: [], cat: 'groom', g: 'ML' },
	{ pet: 'Biscuit', breed: 'Goldendoodle', time: '10:45 AM – 12:00 PM', svc: 'Full Groom — Medium', price: 120, add: ['De-shedding Treatment'], cat: 'groom', g: 'AS', live: true },
	{ now: true },
	{ pet: 'Waffles', breed: 'Corgi', time: '11:00 – 11:45 AM', svc: 'Bath & Brush', price: 55, add: [], cat: 'bath', g: 'ML', drop: true },
	{ pet: 'Peaches', breed: 'Cavapoo', time: '11:00 – 11:30 AM', svc: 'Puppy Intro', price: 35, add: [], cat: 'puppy', g: 'PP' },
	{ pet: 'Bronny', breed: 'Labrador', time: '11:30 AM – 12:10 PM', svc: 'Bath & Brush', price: 55, add: ['Nail Trim'], cat: 'bath', g: 'JK' }
]
function MsCalCard({ a }) {
	const c = MS_CAT[a.cat], g = MS_G[a.g]
	return (
		<div className={'msc-card' + (a.done ? ' done' : '')} style={{ background: c[0], borderColor: c[1] }}>
			<span className="msc-main">
				<span className="msc-time" style={{ color: c[2] }}>
					<span>{a.time}</span>
					{a.done ? <i className="msc-tick"><NIc name="tick" size={10} sw={2.4} /></i> : null}
					{a.live ? <em className="msc-chip">In progress</em> : null}
					{a.live ? <i className="msc-live"></i> : null}
				</span>
				<span className="msc-pet"><strong>{a.pet}</strong><span>{a.breed}</span>{a.drop ? <em className="msc-walkin">Walk-in</em> : null}</span>
				<span className="msc-svcrow"><span className="msc-svc">{a.svc}</span><em>${a.price}</em></span>
				{a.add.map((x) => <span className="msc-add" key={x}><i>+</i><b style={{ fontWeight: 650 }}>{x}</b></span>)}
				<span className="msc-groomer"><i style={{ background: g.ac }}></i>{g.name}</span>
			</span>
		</div>
	)
}
export function MsCalendar({ on }) {
	const phase = useN2Phases(on, [[1300, 'drop']])
	const days = [['S', 5], ['M', 6], ['T', 7], ['W', 8], ['T', 9], ['F', 10], ['S', 11]]
	let d = 0
	return (
		<MsChrome on={on}>
			<header className="msc-head">
				<MsTopbar />
				<div className="msc-titlerow">
					<div className="msc-cluster">
						<span className="msc-navbtn"><NIc name="chevl" size={17} sw={1.9} /></span>
						<span className="msc-title"><strong>July</strong><span>2026</span><NIc name="chevron" size={13} sw={2.1} /></span>
						<span className="msc-navbtn"><NIc name="chevr" size={17} sw={1.9} /></span>
					</div>
					<span className="msc-today">Today</span>
				</div>
			</header>
			<div className="msc-strip">
				{days.map(([wd, n]) => (
					<span key={n} className={'msc-day' + (n === 9 ? ' sel today' : '')}><span className="msc-day-wd">{wd}</span><span className="msc-day-num">{n}</span></span>
				))}
			</div>
			<div className="msc-chips">
				<span className="msc-gall">All</span>
				{Object.keys(MS_G).map((k) => <span className="msc-gchip" key={k}><i className="msc-gav" style={{ background: MS_G[k].chip, color: MS_G[k].deep }}>{k}</i>{MS_G[k].first}</span>)}
			</div>
			<div className="msc-metabar">
				<div className="msc-daymeta"><strong>Thu, Jul 9 · Today</strong><span>{phase === 'drop' ? '15' : '14'} appointments</span></div>
				<div className="msc-modeseg"><span className="on"><NIc name="services" size={15} sw={1.5} /></span><span><NIc name="landing" size={15} sw={1.5} /></span><span><NIc name="calendar" size={15} sw={1.5} /></span></div>
			</div>
			<div className="msc-scroll">
				<div className="msc-list">
					{MS_CAL.map((a, i) => {
						if (a.now) return <div className="msc-now ms-in" key="now" style={{ '--d': (d++ * 0.07) + 's' }}><em>10:47 AM</em><i></i></div>
						if (a.drop) return <div className={'msc-drop' + (phase === 'drop' ? ' in' : '')} key={a.pet}><MsCalCard a={a} /></div>
						return <div className="ms-in" key={a.pet} style={{ '--d': (d++ * 0.07) + 's' }}><MsCalCard a={a} /></div>
					})}
				</div>
			</div>
			<span className="msc-fab"><NIc name="plus" size={20} sw={2} /></span>
		</MsChrome>
	)
}

/* ── 2 · Bookings — requests inbox, Accept & book ── */
const MS_REQS = [
	{ client: 'Harper Quinn', isNew: true, phone: '(415) 555-0132', ago: '2h ago', when: 'Mon, Jul 20 · 9:00 AM', foot: '1 pet · 80 min', total: '$119',
		pets: [{ name: 'Waffles', breed: 'Goldendoodle', pic: 'doodle', svc: 'Full Groom — Medium', mins: 80, price: '$119', add: ['Teeth Brushing', 'Blueberry Facial'] }],
		note: 'First groom since adoption — she’s shy but very sweet. Please go slow with the dryer.' },
	{ client: 'Kevin Tran', multi: true, phone: '(415) 555-0178', ago: '4h ago', when: 'Mon, Jul 20 · 10:00 AM', foot: '2 pets · 120 min · prefers Ashley', total: '$181',
		conflict: 'Double-books Scout · 11:30 AM–12:10 PM with Jordan',
		pets: [{ name: 'Milo', breed: 'Pembroke Welsh Corgi', pic: 'corgi', svc: 'Bath & Brush', mins: 50, price: '$77', add: ['Ear Cleaning', 'Nail Trim'] },
			{ name: 'Peaches', breed: 'Cavalier King Charles', pic: 'cavalier', svc: 'Full Groom — Small', mins: 70, price: '$104', add: ['Teeth Brushing', 'De-shedding Treatment'] }] }
]
function MsReq({ r, gone = false, phase = 'idle', tap = false }) {
	return (
		<article className={'msb-req' + (gone ? ' gone' : '')}>
			<header className="msb-top">
				<div className="msb-id">
					<div className="msb-idline">
						<strong>{r.client}</strong>
						{r.isNew ? <span className="msb-flag first"><NIc name="spark" size={10} sw={2} />New client</span> : null}
						{r.multi ? <span className="msb-flag multi"><NPaw size={10} />{r.pets.length} pets</span> : null}
					</div>
					<span className="msb-sub">{r.phone}</span>
				</div>
				<span className="msb-ago">{r.ago}</span>
			</header>
			<div className="msb-ask">
				<div className="msb-when"><NIc name="calendar" size={13} sw={1.8} />{r.when}</div>
				{r.pets.map((p) => (
					<div className="msb-pet" key={p.name}>
						<SclPetPic kind={p.pic} size={30} />
						<div className="msb-petmid">
							<div className="msb-petid"><strong>{p.name}</strong><span className="msb-breed">{p.breed}</span></div>
							<div className="msb-svc">{p.svc}<span>{p.mins} min</span></div>
							{p.add.map((a) => <span className="msb-addon" key={a}><i>+</i>{a}</span>)}
						</div>
						<span className="msb-price">{p.price}</span>
					</div>
				))}
				<div className="msb-foot"><span>{r.foot}</span><strong>{r.total}</strong></div>
			</div>
			{r.conflict ? <div className="msb-warn"><NIc name="warn" size={14} sw={1.8} /><span>{r.conflict}</span></div> : null}
			{r.note ? <p className="msb-note">“{r.note}”</p> : null}
			<span className={'msb-accept' + (phase === 'press' ? ' pressed' : '')}>
				<N2Ic name="check" size={15} sw={2.4} />Accept &amp; book
				{tap ? <MsTap show={phase === 'tap' || phase === 'press'} press={phase === 'press'} x="56%" y="50%" /> : null}
			</span>
			<div className="msb-alt">
				<span className="msb-link"><NIc name="messages" size={13} sw={1.7} />Message {r.client.split(' ')[0]}</span>
				<span className="msb-link danger">Decline</span>
			</div>
		</article>
	)
}
export function MsBookings({ on }) {
	const phase = useN2Phases(on, [[1500, 'tap'], [2300, 'press'], [2750, 'booked']])
	const booked = phase === 'booked'
	return (
		<MsChrome on={on}>
			<header className="ms-head">
				<MsTopbar />
				<div className="ms-titlerow"><h1>Bookings</h1></div>
				<div className="ms-tabs">
					<span className="ms-tab on">Requests<em className="ms-tabn">{booked ? 4 : 5}</em></span>
					<span className="ms-tab">Upcoming</span>
					<span className="ms-tab">Waitlist<em className="ms-tabn">7</em></span>
					<span className="ms-tab">History</span>
				</div>
				<div className="ms-search"><NIc name="search" size={16} sw={1.8} />Search requests</div>
			</header>
			<div className="ms-list">
				<div className="ms-in" style={{ '--d': '.05s' }}><MsReq r={MS_REQS[0]} gone={booked} phase={phase} tap /></div>
				<div className="ms-in" style={{ '--d': '.14s' }}><MsReq r={MS_REQS[1]} /></div>
			</div>
			<div className={'msb-toast' + (booked ? ' show' : '')}>
				<span className="msb-toast-ic"><N2Ic name="check" size={12} sw={3} /></span>
				<span className="msg">Booked <strong>Waffles</strong> · Mon, Jul 20 · 9:00 AM — confirmation texted to Harper</span>
			</div>
		</MsChrome>
	)
}

/* ── 3 · Clients & Pets — list → Client Details → Pets tab ── */
const MS_CLIENTS = [
	{ name: 'Alex Morgan', isNew: true, pets: ['Cooper', 'Luna'], pics: ['lab', 'doodle'], next: 'Sep 25, 10:00 AM', phone: '(212) 419-2230' },
	{ name: 'Sarah Miller', isNew: true, pets: ['Mr Cuddles'], pics: ['poodle'], next: 'Sep 30, 11:00 AM', phone: '(310) 487-5298' },
	{ name: 'Maya Thompson', isNew: true, pets: ['Nori', 'Charlie', 'Willow'], pics: ['cat', 'golden', 'poodle'], next: 'Sep 24, 1:00 PM', phone: '(818) 555-0142', hit: true },
	{ name: 'Dora Explora', isNew: false, pets: ['Brian'], pics: ['corgi'], next: 'Sep 26, 12:30 PM', phone: '(415) 320-0020' },
	{ name: 'Hugh Jackman', isNew: false, pets: ['Wolverine', 'Logan'], pics: ['cavalier', 'lab'], next: null, phone: '(312) 415-2280' },
	{ name: 'Tom Brady', isNew: false, pets: ['Bronny'], pics: ['corgi'], next: 'Sep 25, 1:00 PM', phone: '(256) 723-9914' }
]
const MS_PETS = [
	{ name: 'Nori', species: 'Cat', breed: 'Domestic Shorthair', pic: 'cat', weight: '9 lbs', sex: 'Female', dob: 'Jan 14, 2023', open: true,
		notes: [['Medical', 'Healthy; sensitive ears — skip the flush.'], ['Grooming', 'Quick brush-outs — taps out after 20 min.'], ['Personality', 'Shy at drop-off, settles fast.']] },
	{ name: 'Charlie', species: 'Dog', breed: 'Golden Retriever', pic: 'golden', weight: '64 lbs', sex: 'Male', dob: 'Mar 2, 2022', notes: [] }
]
export function MsClients({ on }) {
	const phase = useN2Phases(on, [[1000, 'tap'], [1800, 'press'], [2250, 'detail'], [4200, 'tap2'], [4900, 'press2'], [5300, 'pets']])
	const P = ['idle', 'tap', 'press', 'detail', 'tap2', 'press2', 'pets']
	const at = (p) => P.indexOf(phase) >= P.indexOf(p)
	const pets = at('pets')
	return (
		<MsChrome on={on}>
			<header className="ms-head">
				<MsTopbar />
				<div className="ms-titlerow"><h1 className="sm">Clients &amp; Pets</h1><span className="ms-addbtn"><NIc name="plus" size={15} sw={2} />New</span></div>
				<div className="ms-count">7 clients</div>
				<div className="ms-search"><NIc name="search" size={16} sw={1.8} />Search clients or pets</div>
			</header>
			<div className="ms-list" style={{ gap: 10 }}>
				{MS_CLIENTS.map((c, i) => (
					<div className={'mscl-card ms-in' + (c.hit && (phase === 'press') ? ' hit' : '')} key={c.name} style={{ '--d': (0.04 + i * 0.06) + 's' }}>
						<div className="mscl-top">
							<div className="mscl-id">
								<span className="mscl-name"><strong>{c.name}</strong>{c.isNew ? <span className="mscl-new">New</span> : null}</span>
								<span className="mscl-pets">
									<span className="mscl-stack">{c.pets.map((p, j) => <i className="scl-pav" key={p} style={{ zIndex: 3 - j }}><SclPetPic kind={c.pics[j]} size={22} /></i>)}</span>
									{c.pets.join(', ')}
								</span>
							</div>
							<span className="mscl-chev"><NIc name="chevr" size={14} sw={1.8} /></span>
						</div>
						<div className="mscl-bottom">
							<span className={'mscl-next' + (c.next ? '' : ' none')}><NIc name="calendar" size={12} sw={1.8} />{c.next || 'No upcoming visit'}</span>
							<span className="mscl-meta">{c.phone}</span>
						</div>
						{c.hit ? <MsTap show={phase === 'tap' || phase === 'press'} press={phase === 'press'} x="62%" y="42%" /> : null}
					</div>
				))}
			</div>

			<div className={'mscl-detail' + (at('detail') ? ' in' : '')} aria-hidden={!at('detail')}>
				<header className="mscl-subhead">
					<span className="mscl-back"><NIc name="chevl" size={17} sw={1.8} /></span>
					<strong className="mscl-subtitle">Client Details</strong>
					<span className="ms-icbtn"><NIc name="pencil" size={15} sw={1.7} /></span>
				</header>
				<div className="mscl-body">
					<div className="mscl-idmain">
						<span className="mscl-name"><strong>Maya Thompson</strong><span className="mscl-new">New</span></span>
						<span className="mscl-since">Client since Aug 12, 2025</span>
					</div>
					<div className="mscl-actions">
						<span className="mscl-btn primary"><NIc name="calendar" size={15} sw={1.8} />Book appointment</span>
						<div className="mscl-row">
							<span className="mscl-btn ghost"><NIc name="messages" size={15} sw={1.7} />Message</span>
							<span className="mscl-btn ghost"><N2Ic name="send" size={14} sw={1.9} />Agreements</span>
						</div>
					</div>
					<div className="mscl-tabs">
						<span className={'mscl-tab' + (pets ? '' : ' on')}>Overview</span>
						<span className={'mscl-tab' + (pets ? ' on' : '') + (phase === 'press2' ? ' pressed' : '')}>Pets<em className="mscl-tabn">3</em>
							<MsTap show={phase === 'tap2' || phase === 'press2'} press={phase === 'press2'} x="50%" y="50%" />
						</span>
						<span className="mscl-tab">History</span>
					</div>
					{!pets ? (
						<div className="mscl-pane" key="ov">
							<div className="mscl-stats">
								<span className="mscl-stat"><strong>5</strong><span>Total bookings</span></span>
								<span className="mscl-statsep"></span>
								<span className="mscl-stat"><strong>2</strong><span>Completed</span></span>
							</div>
							<section className="mscl-panel">
								<span className="mscl-sect">Information</span>
								<div className="mscl-info">
									<span><NIc name="user" size={14} sw={1.7} />(818) 555-0142</span>
									<span><NIc name="mail" size={14} sw={1.7} />mayathompson@gmail.com</span>
									<span><NIc name="pin" size={14} sw={1.7} />2500 Wilshire Blvd, Los Angeles, CA</span>
								</div>
							</section>
							<section className="mscl-panel">
								<span className="mscl-sect">Next appointment</span>
								<div className="mscl-up">
									<div className="top"><strong>Sep 24, 2025</strong><span>1:00 – 2:00 PM</span></div>
									<div className="pet"><i></i><div className="svc"><strong>Charlie</strong><span>Full Groom — Large</span></div></div>
									<span className="add">+ Nail Trim</span>
									<span className="add">+ Teeth Brushing</span>
									<div className="foot"><NIc name="user" size={12} sw={1.7} /><span>Mike Chen</span><strong>$95</strong></div>
								</div>
							</section>
						</div>
					) : (
						<div className="mscl-pane" key="pets">
							{MS_PETS.map((p) => (
								<div className="mscl-pet" key={p.name}>
									<div className="mscl-petid">
										<SclPetPic kind={p.pic} size={46} />
										<div className="mscl-pettx"><strong>{p.name}</strong><span>{p.breed} · {p.species}</span></div>
										<span className="mscl-edit"><NIc name="pencil" size={13} sw={1.7} /></span>
									</div>
									<div className="mscl-keys">
										<div className="mscl-key"><em>Weight</em><strong>{p.weight}</strong></div>
										<div className="mscl-key"><em>Gender</em><strong>{p.sex}</strong></div>
										<div className="mscl-key"><em>Date of birth</em><strong>{p.dob}</strong></div>
									</div>
									<div className={'mscl-more' + (p.open ? ' open' : '')}><span>Care notes</span><NIc name="chevron" size={14} sw={1.8} /></div>
									{p.open ? <div className="mscl-notes">{p.notes.map(([k, v]) => <div className="mscl-note" key={k}><em>{k}</em><p>{v}</p></div>)}</div> : null}
								</div>
							))}
						</div>
					)}
				</div>
			</div>
		</MsChrome>
	)
}

/* ── 4 · Messages + AI — a text becomes a booking ── */
export function MsMessages({ on }) {
	const phase = useN2Phases(on, [[500, 'b1'], [1400, 'b2'], [2500, 'tap1'], [3200, 'press1'], [3600, 'sheet'], [5500, 'tap2'], [6200, 'press2'], [6700, 'booked']])
	const P = ['idle', 'b1', 'b2', 'tap1', 'press1', 'sheet', 'tap2', 'press2', 'booked']
	const at = (p) => P.indexOf(phase) >= P.indexOf(p)
	const sheet = at('sheet') && !at('booked')
	const booked = at('booked')
	return (
		<MsChrome on={on}>
			<header className="msm-head">
				<span className="msm-back"><NIc name="chevl" size={20} sw={2} /></span>
				<span className="msm-id"><span className="msm-ava">RC</span><span className="msm-name"><strong>Renee Cho</strong><span>(415) 555-0173</span></span></span>
				<span className="msm-info"><NIc name="help" size={21} sw={1.6} /></span>
			</header>
			<div className="msm-scroll">
				<div className="msm-day">Today</div>
				<div className={'msm-bub' + (at('b1') ? ' in' : '')}><p>Hi! Do you have any openings this Saturday to get Cooper groomed? He’s a Labrador — needs a full groom and probably a nail trim too.</p><span>9:48 AM</span></div>
				<div className={'msm-bub' + (at('b2') ? ' in' : '')}><p>Late morning would be ideal, around 11 if you have it.</p><span>9:49 AM</span></div>
				<div className={'msm-card' + (booked ? ' in' : '')}>
					<span className="msm-card-ic"><NIc name="checkc" size={16} sw={1.9} /></span>
					<div><strong>Appointment booked</strong><span>Cooper · Full Groom — Large + Nail Trim</span><span>Sat, Jun 20 · 11:00 AM · Ashley</span></div>
				</div>
				<div className={'msm-bub auto' + (booked ? ' in' : '')}><p>Hi Renee! You’re booked: Cooper, Full Groom — Large on Sat, Jun 20 at 11:00 AM. Reply R to reschedule.</p><span>Sent automatically · just now</span></div>
			</div>
			<div className="msm-aibar">
				<span className="msm-aiic"><NIc name="spark" size={16} sw={1.9} /></span>
				<div className="msm-aitx">
					<strong>{booked ? 'Appointment created' : 'Booking request detected'}<em className="msm-aitag">AI</em></strong>
					<span>{booked ? 'Added to the calendar · confirmation texted' : 'Create an appointment from this conversation'}</span>
				</div>
				<span className={'msm-aibtn' + (phase === 'press1' ? ' pressed' : '') + (booked ? ' done' : '')}>
					{booked ? <React.Fragment><N2Ic name="check" size={15} sw={2.4} />Booked · Sat, Jun 20 · 11:00 AM</React.Fragment> : <React.Fragment><NIc name="calendar" size={15} sw={1.8} />Create appointment</React.Fragment>}
					<MsTap show={phase === 'tap1' || phase === 'press1'} press={phase === 'press1'} x="54%" y="50%" />
				</span>
			</div>
			<footer className="msm-composer">
				<span className="msm-qr"><N2Ic name="zap" size={16} sw={1.9} /></span>
				<span className="msm-input">Text Renee…</span>
				<span className="msm-send"><N2Ic name="send" size={16} sw={2} /></span>
			</footer>

			<div className={'msm-scrim' + (sheet ? ' show' : '')} aria-hidden={!sheet}>
				<div className="msm-sheet">
					<div className="msm-grab"></div>
					<div className="msm-sh-head">
						<span className="msm-sh-ic"><NIc name="spark" size={16} sw={1.9} /></span>
						<div><strong>Create appointment<em className="msm-aitag">AI</em></strong><span>Auto-filled from Renee’s messages · review &amp; book</span></div>
						<span className="msm-sh-x"><NIc name="x" size={13} sw={2} /></span>
					</div>
					<div className="msm-note">AI-tagged fields were pulled from the conversation — adjust anything before booking.</div>
					<div className="msm-sec">
						<span className="msm-sec-t">When<em className="msm-aitag">AI</em></span>
						<div className="msm-pair">
							<span className="msm-fld"><NIc name="calendar" size={14} sw={1.7} />Sat, Jun 20<i className="chev"><NIc name="chevron" size={12} sw={1.8} /></i></span>
							<span className="msm-fld"><NIc name="clock" size={14} sw={1.7} />11:00 AM<i className="chev"><NIc name="chevron" size={12} sw={1.8} /></i></span>
						</div>
					</div>
					<div className="msm-sec">
						<span className="msm-sec-t">Client &amp; pet<em className="msm-aitag">AI</em></span>
						<div className="msm-fields">
							<span className="msm-fld"><NIc name="user" size={14} sw={1.7} />Renee Cho</span>
							<span className="msm-fld"><NPaw size={14} />Cooper · Labrador Retriever<i className="chev"><NIc name="chevron" size={12} sw={1.8} /></i></span>
						</div>
					</div>
					<div className="msm-sec">
						<span className="msm-sec-t">Service<em className="msm-aitag">AI</em></span>
						<div className="msm-fields">
							<span className="msm-fld"><NIc name="services" size={14} sw={1.7} />Full Groom — Large · $110 · 75 min<i className="chev"><NIc name="chevron" size={12} sw={1.8} /></i></span>
							<span className="msm-fld"><NIc name="plus" size={14} sw={1.9} />Nail Trim · $12 · 15 min<i className="chev"><NIc name="chevron" size={12} sw={1.8} /></i></span>
						</div>
					</div>
					<span className="msm-ends">Ends at <strong>12:30 PM</strong> · $122 · with Ashley</span>
					<span className={'msm-sh-go' + (phase === 'press2' ? ' pressed' : '')}>
						<NIc name="calendar" size={15} sw={1.8} />Create appointment
						<MsTap show={phase === 'tap2' || phase === 'press2'} press={phase === 'press2'} x="58%" y="50%" />
					</span>
				</div>
			</div>
		</MsChrome>
	)
}
